<i [ngClass]="['cfe', 'cfe-' + iconName]"></i>
